import { useRef } from 'react';

/**
 * Updates the components height in the styling.
 * Used for transitions where height is unknown.
 * And it needs to be known for an proper transition effect
 * Used for open close transition of weather warnings
 */
export function GetTransitionHeight({ className, children }: { className?: string; children: JSX.Element }) {
  const anim = useRef<HTMLDivElement>(null);
  const height = anim.current?.scrollHeight;
  if (height) {
    anim.current?.style.setProperty('--max-height', height + 'px');
  }

  return (
    <div data-module="transition-height" className={className} ref={anim}>
      {children}
    </div>
  );
}
